import { Union } from "../../fable-library-js.4.25.0/Types.js";
import { Common_GenericOptions__AddModifiers_Z7C3AFA3, Common_GenericOptions__AddProps_Z4E55E0BD, Color_ofColor, Common_GenericOptions__AddClass_Z721C83C5, Common_GenericOptions__AddProp_ZCC5A61F, Common_GenericOptions_Parse_Z4D1A7726, Common_GenericOptions__ToReactElement_4509C2D7, Modifier_IModifier_$reflection, Color_IColor_$reflection, Size_ISize_$reflection } from "../Common.fs.js";
import { union_type, string_type, int32_type, list_type, class_type } from "../../fable-library-js.4.25.0/Reflection.js";
import * as react from "react";
import { keyValueList } from "../../fable-library-js.4.25.0/MapUtil.js";
import { HTMLAttr } from "../../Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Reflection_getCaseName } from "../Common.fs.js";

export class Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Size", "Color", "Props", "Value", "Max", "CustomClass", "Modifiers"];
    }
}

export function Option_$reflection() {
    return union_type("Fulma.Progress.Option", [], Option, () => [[["Item", Size_ISize_$reflection()]], [["Item", Color_IColor_$reflection()]], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", int32_type]], [["Item", int32_type]], [["Item", string_type]], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

/**
 * Generate <progress class="progress"></progress>
 */
export function progress(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 4:
                return Common_GenericOptions__AddProp_ZCC5A61F(result, new HTMLAttr(114, [option.fields[0]]));
            case 0:
                return Common_GenericOptions__AddClass_Z721C83C5(result, Reflection_getCaseName(option.fields[0]));
            case 1:
                return Common_GenericOptions__AddClass_Z721C83C5(result, Color_ofColor(option.fields[0]));
            case 2:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 5:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 6:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
            default:
                return Common_GenericOptions__AddProp_ZCC5A61F(result, new HTMLAttr(161, [option.fields[0]]));
        }
    }, "progress"), (props_1, children_1) => react.createElement("progress", keyValueList(props_1, 1), ...children_1), children);
}

